module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p9.5d5e981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p9.png
// module id = Kj2E
// module chunks = 10